// extracted by mini-css-extract-plugin
export var chip = "_4i-0";
export var filterDropdown = "_4i-5";
export var filterItem = "_4i-6";
export var icon = "_4i-1";
export var removeButton = "_4i-3";
export var removeIcon = "_4i-4";
export var separator = "_4i-2";